<template>
<div class = "gallery-listing">
  <div class = "loading-wrapper" v-if = "state.gallery.isLoading">
    <b-loading :is-full-page="false" :active.sync="state.gallery.isLoading" :can-cancel="false"></b-loading>
  </div>
  <div v-else class = "gallery-items">
    <gallery-item v-for = "item in galleryItems.results" :key = "item.id" :galleryItem = "item"></gallery-item>
  </div>

  <div v-if = "showPaging" class = "pagination">
    <div>
      <router-link class = "btn btn-bg-colored" :class = "{ disabled: previousDisabled }" :to="{ name: 'Gallery', params: { 'page': previousPage() } }" v-scroll-to = "'.gallery-listing'">Anterior <!--({{previousPage()}})--></router-link>
      <router-link class = "btn btn-bg-colored" :class = "{ disabled: nextDisabled }" :to="{ name: 'Gallery', params: { 'page': nextPage() } }" v-scroll-to = "'.gallery-listing'">Siguiente <!--({{nextPage()}})--></router-link>
    </div>
    <div class = "pages">
      <router-link v-for = "i in numPages" :key = "i" :to="{ name: 'Gallery', params: { 'page': i } }" v-scroll-to = "'.gallery-listing'" :class = "{ 'selected': i === parseInt($route.params.page) }">{{i}}</router-link>
    </div>
  </div>
</div>
</template>

<script>
import GalleryItem from './GalleryItem'

export default {
  name: 'Gallery',
  components: {
    GalleryItem
  },
  props: {
    searchParams: Object,
    showPaging: {
      default: false
    }
  },
  data () {
    return {
      previousDisabled: true,
      nextDisabled: false
    }
  },
  watch: {
    '$route': function (oldRoute, newRoute) {
      this.loadGallery()
    }
  },
  computed: {
    numPages () {
      return this.$store.state.gallery.numPages
    },
    galleryItems () {
      return this.$store.state.gallery.fetched
    },
    state () {
      return this.$store.state
    }
  },
  methods: {
    loadGallery: function () {
      // console.log('--> ' + this.$route.params.page)

      this.searchParams.page = this.$route.params.page
      let query = {
        params: this.searchParams
      }
      // console.log(query)
      this.$store.dispatch('fetchProjectList', query)
    },
    previousPage: function () {
      if (this.$route.params.page === 1) {
        // disable previous button
        this.previousDisabled = true
      } else {
        this.previousDisabled = false

        return parseInt(this.$route.params.page) - 1
      }
    },
    nextPage: function () {
      // console.log('nextPage', this.$route.params.page)

      if (this.$route.params.page === this.$store.state.gallery.numPages) {
        // disable next button
        this.nextDisabled = true
        return this.$route.params.page
      } else {
        // console.log('nextPage', parseInt(this.$route.params.page) + 1)
        this.nextDisabled = false

        return parseInt(this.$route.params.page) + 1
      }
    }
  },
  created () {
    this.loadGallery()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

@media (max-width: @breakPoint) {
  .gallery-items {
    grid-template: ~"auto 1fr / 1fr 1fr !important";
  }

  .cover {
    height: unset !important;
  }
}

.gallery {
  background: @backgroundColor;
  // height: 100vh;

  & > * {
    padding: 10px;
  }

}

.description {
  font-size: 1.5em;
  padding: 0 15px;
  color: #8c8c8c;
}

.content {
  padding: 20px;
}

.gallery-items {
  display: grid;
  grid-template-columns: repeat(auto-fill,minmax(200px,1fr));
  grid-gap: 30px;
  justify-items: center;
}

.loading-wrapper {
  position: relative;
  height: 100px;
}

.pagination {
  display: flex;
  flex-direction: column;
  margin: 30px;

  .pages a {
    color: #555;
    font-weight: 800;
    padding: 5px;
    display: inline-block;
    border-bottom: 3px solid transparent;

    &:hover, &.selected {
      border-bottom: 3px solid @accentColor;
    }
  }

  & > * {
    padding: 30px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Gallery/GalleryListing.vue